import { render, staticRenderFns } from "./TreatmentTypeList.vue?vue&type=template&id=bea90b82&scoped=true"
import script from "./TreatmentTypeList.vue?vue&type=script&lang=js"
export * from "./TreatmentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea90b82",
  null
  
)

export default component.exports